<template>
  <v-dialog
      class="hide-on-print"
      v-model="innerOpen"
      persistent
      width="800">

    <v-card class="hide-on-print">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Pay manually</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-form lazy-validation ref="manualRef">
          <v-layout row wrap class="px-0 pt-5">

            <v-flex xs6>
              <v-text-field
                  label="Bank name *"
                  outlined
                  :value="bank_name"
                  :disabled="true"
              />
            </v-flex>
            <v-flex xs6 class="pl-2">
              <v-text-field
                  label="Invoice number *"
                  outlined
                  v-model="paymentData.invoice_number"
                  :rules="[rules.required,rules.invoice_number]"
              />
            </v-flex>
            <v-flex xs6>

              <v-text-field
                  label="Amount (USD) *"
                  outlined
                  type="number"
                  :rules="[rules.required]"
                  v-model="paymentData.cost"
                  onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
              />
            </v-flex>
            <v-flex xs6 class="pl-2">
              <v-text-field
                  label="Amount (NPR) *"
                  outlined
                  type="number"
                  readonly
                  :hint="'Exchange rate of NPR '+npr_rate"
                  v-model="nprAmount"
                  :rules="[rules.required]"
                  onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
              />
            </v-flex>

            <v-flex xs12>
              <multiple-file-upload v-model="paymentData.files"
                                    :required="true"
                                    label="Please Upload Bank Receipt *"
              />
            </v-flex>

          </v-layout>
        </v-form>

      </v-card-text>
      <v-divider style="margin-top:31px;"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            @click="cancel"
            class="white--text"
            color="red darken-3"
        >Cancel
        </v-btn>
        <v-btn
            :loading="loading"
            @click="save"
            class="white--text"
            color="blue darken-3"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "../../mixins/validationMixin";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios"
import MultipleFileUpload from "../MultipleFileUpload";

export default {
  name: "ManualPaymentDialog",
  components: {MultipleFileUpload},
  props: ['value', 'url'],
  mixins: [validationMixin],
  data() {
    return {
      paymentData: {},
      innerOpen: false,
      bank_name: '',
      npr_rate: "",
      loading: false,
    }
  },
  watch: {
    value(input) {
      this.innerOpen = input;
    },
    innerOpen(value) {
    }
  },
  computed: {
    nprAmount() {
      return (this.paymentData.cost * this.npr_rate).toFixed(2);
    }
  },
  async mounted() {
    Http.get(`${VERSIONED_API_URL}/user-bank`).then((res) => {
      this.bank_name = res.data.bank_name;
    });

    Http.get(`${VERSIONED_API_URL}/get-npr-rate`).then((res) => {
      this.npr_rate = res.data
    })
  },
  methods: {
    async save() {
      if (this.$refs.manualRef.validate()) {
        this.loading = true;
        let formData = new FormData();
        formData.append("invoice_number", this.paymentData.invoice_number);
        formData.append("cost", this.paymentData.cost);
        formData.append("bank_name", this.bank_name);
        if (this.paymentData.files !== undefined) {
          for (let i = 0; i < this.paymentData.files.length; i++) {
            formData.append(`files[${i}]`, this.paymentData.files[i])
          }
        }
        try {

          const response = await Http.post(VERSIONED_API_URL + '/' + this.url, formData);
          this.$store.commit('Notification/showSuccess', response.data.message);
          this.paymentData = {};
          this.$emit('input', false);
          this.innerOpen = false;
          this.loading = false;
          this.$emit('paid')
        } catch (e) {
          this.$store.commit('Notification/showError', e.response.data.message);
          this.loading = false;
        }

      }
    },
    cancel() {
      this.paymentData = {};
      this.innerOpen = false;
      this.$emit('input', false)
    }
  }
}
</script>

